export const RESEND_OTP_TIMER = 45000
export const RESEND_CODE_TIMER = 45000
export const VERIFICATION_CODE_LENGTH = 5
export const MESA_MORTGAGE_POINTS_EARNED_PER_DOLLAR = 1
export const MESA_MORTGAGE_REFI_POINTS_EARNED_PER_DOLLAR = 1
